import i18n from '@src/common/lib/i18n'
export const tableOption = function() {
  return {
    selection: true,
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    size: 'mini',
    align: 'left',
    maxHeight: '100%',
    menuWidth: 120,
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 'auto',
    dialogWidth: '40%',
    emptyText: i18n.t('deviceMg.title.information'),
    column: [
      {
        label: i18n.t('deviceMg.label.cameraName'),
        prop: 'bayonetName',
        addDisplay: true,
        editDisplay: true,
        search: true,
        viewDisplay: false,
        labelWidth:110,
        rules: [
          { required: true, message: i18n.t('deviceMg.message.cameraName'), trigger: 'blur' },
          { min: 3, max: 20, message: i18n.t('deviceMg.message.length'), trigger: 'blur' }
        ],
        span: 15
      },
      {
        label: i18n.t('deviceMg.label.area'),
        prop: 'areaDevGroupName',
        type: 'cascader',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: false,
        dicData:[{
          label: '区域一',
          value: 0,
          children:[
            {
              label: '区域一',
              value: 0,
              children:[
                {
                  label: '区域一',
                  value: 0
                },
                {
                  label: '区域二',
                  value: 0
                }
              ]
            },
            {
              label: '区域二',
              value: 0
            }
          ]
        }, {
          label: '区域二',
          value: 1
        }],
        labelWidth:110,
        span: 13
      },
      {
        label: i18n.t('deviceMg.label.type'),
        prop: 'type',
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        search: true,
        viewDisplay: false,
        dicData:[{
          label: i18n.t('deviceMg.label.car'),
          value: 1
        }, {
          label: i18n.t('deviceMg.label.people'),
          value: 2
        }],
        formatter: function (row, value) {
          let str = ''
          if (value == 1) {
            str = i18n.t('deviceMg.label.car')
          }
          if (value == 2) {
            str = i18n.t('deviceMg.label.people')
          }
          return str
          // return value ? utils.Dates.dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
        },
        valueDefault: 0,
        labelWidth:110,
        span: 15
      },
      {
        label: i18n.t('deviceMg.label.createTime'),
        prop: 'createTime',
        type: 'datetimerange',
        addDisplay: false,
        editDisplay: false,
        search: true,
        viewDisplay: false,
        span: 13,
        startPlaceholder: i18n.t('deviceMg.placeholder.startTime'),
        endPlaceholder: i18n.t('deviceMg.placeholder.endTime')
      }
    ]
  }
}
